import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { QuoteService } from '../../services/quote.service';
import { map } from 'rxjs/operators';

@Injectable()
export class QuoteGuard implements CanActivate {

    constructor(
        private quoteService: QuoteService,
        private router: Router) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.quoteService.stocklines$.pipe(
            map((data: any[]) => {
                if (data.length > 0) {
                    return true;
                } else {
                    this.router.navigateByUrl("/quotes/pricelist")
                    return false;
                }
            })
        )
        //throw new Error('Method not implemented.');
    }

}